interface IMARGIN_FORMULA {
  cost: number;
  choicePerc: string;
  margin: number;
  markup: number;
}

export const MARGIN_FORMULA = ({
  cost,
  choicePerc,
  margin,
  markup,
}: IMARGIN_FORMULA) => {
  const Cost = Number(cost);
  const Margin = Number(margin);
  const Markup = Number(markup);
  const choice = choicePerc;
  if (
    Cost < 0 ||
    Cost > 1e10 ||
    Margin < 0 ||
    Margin > 99 ||
    Markup < 0 ||
    Markup > 1e5
  ) {
    const res = 0;
    return {
      revenue: res,
      profit: res,
    };
  }
  const revenue =
    choice === 'MARGIN'
      ? Cost / (1 - Margin / 100)
      : Cost + (Cost * Markup) / 100;
  const profit = revenue - Cost;
  return {
    revenue: Math.round(revenue * 100) / 100,
    profit: Math.round(profit * 100) / 100,
  };
};
